/* @flow */
import React from 'react';

export default function GDCAppsMenuIcon({
  style
}: Object): React.Element {
  return (<i className="icon-gdc-apps-menu" style={style}></i>);
}
